export default {
  meta: {
    title: '用户协议-路过',
    // url: '/user-agreement', // 埋点字段，上报归属的模块
    urlName: '用户协议-路过' // 埋点字段，上报归属的模块
  }
};
